module.exports = __webpack_public_path__ + "img/center-expand.ed7e2033.svg";